import request from '../../utils/request';
import {fileService} from "@/api/common/file-utils";

export const apiService = {
    search: (data) => {
        return request({
            url: '/engagement/query',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    save: (data) => {
        return request({
            url: '/engagement/save',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    submit: (data) => {
        return request({
            url: '/engagement/submit',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    getById: (id) => {
        return request({
            url: '/engagement/queryEngagement/' + id,
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
        })
    },
    downloadPdf: (id) => request({
        url: '/engagement/downloadPdf/' + id,
        method: 'get',
        fullResponse: true,
        responseType: 'blob'
    }).then(resp => {
        fileService.respToFile(resp,'PDF.pdf');
    }),
    queryPrimaryKey: () => {
        return request({
            url: '/engagement/queryPrimaryKey',
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
        })
    },
    queryRegistAddress: (id) => {
        return request({
            url: '/engagement/queryRegistAddress/' + id,
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
        })
    },
}